import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    flex

    h-8
    min-w-0
    max-w-full

    flex-[0_0_auto]
  `,
  slots: {
    link: `
      flex
      items-center
      justify-center

      rounded-full
      border

      px-4
      text-sm
    `,
  },
  variants: {
    isActive: {
      true: {
        link: `
          border-2
          border-green-700
          bg-green-100
        `,
      },
      false: {
        link: `
          border-gray-300
          hover:bg-gray-100
        `,
      },
    },
    isDisabled: {
      true: {
        link: `
          border-dashed
          opacity-50
        `,
      },
    },
  },
});
